module.exports = __webpack_public_path__ + "static/media/G0142657_China-12.4618091a.png";